import { Routes } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Route } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import { ProtectedRouter } from 'infrastructure/routing';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import PositionProfilesListPage from './List';
import PositionProfileDetailsPage from './show';
import {
  PEOPLE_MANAGEMENT_POSITION_PROFILE_READ,
  POSITION_PROFILE_LIST_READ,
  POSITION_PROFILES_PATH,
} from './constants';
import { usePositionProfilesRoute } from './routing';

const PositionProfilesRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute } = usePositionProfilesRoute();

  return (
    <ProtectedRouter basePath={POSITION_PROFILES_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={POSITION_PROFILE_LIST_READ}>
              <PositionProfilesListPage />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={PEOPLE_MANAGEMENT_POSITION_PROFILE_READ}>
              <PositionProfileDetailsPage />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

PositionProfilesRouter.getRouterPath = () => `${POSITION_PROFILES_PATH}/*`;

export default PositionProfilesRouter;
